// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as Color$YourProjectName from "../color.bs.js";
import * as AppState$YourProjectName from "../appState.bs.js";

function convert(a, b, st) {
  var x = a * st.scale;
  var y = st.svgy - b * st.scale;
  return [
          x,
          y
        ];
}

function convertP(param, st) {
  return convert(param[0], param[1], st);
}

var fontSize = "14";

function coordToSVG(state, c) {
  var match = convert(c.x, c.y, state);
  var y = match[1];
  var x = match[0];
  return {
          hd: React.createElement("circle", {
                key: "coord_" + c.coordinate_id,
                cx: String(x),
                cy: String(y),
                fill: "none",
                r: "2",
                stroke: "black"
              }),
          tl: {
            hd: React.createElement("text", {
                  key: "text_" + c.coordinate_id,
                  fontSize: fontSize,
                  textAnchor: "middle",
                  x: String(x),
                  y: String(y - 8)
                }, c.coordinate_id),
            tl: /* [] */0
          }
        };
}

function controlPoint(x, y, d) {
  switch (d) {
    case /* Above */0 :
        return [
                x,
                y + 0.5
              ];
    case /* Below */1 :
        return [
                x,
                y - 0.5
              ];
    case /* Left */2 :
        return [
                x - 0.5,
                y
              ];
    case /* Right */3 :
        return [
                x + 0.5,
                y
              ];
    
  }
}

function edgeCurveD(state, e) {
  var cs = state.coordinates;
  var sname = e.scoord;
  var tname = e.tcoord;
  var c = AppState$YourProjectName.findCoordinate(cs, sname);
  var match = c !== undefined ? [
      c.x,
      c.y
    ] : [
      0,
      0
    ];
  var sy = match[1];
  var sx = match[0];
  var c$1 = AppState$YourProjectName.findCoordinate(cs, tname);
  var match$1 = c$1 !== undefined ? [
      c$1.x,
      c$1.y
    ] : [
      0,
      0
    ];
  var ty = match$1[1];
  var tx = match$1[0];
  var match$2 = convert(sx, sy, state);
  var sY = match$2[1];
  var sX = match$2[0];
  var match$3 = convert(tx, ty, state);
  var tY = match$3[1];
  var tX = match$3[0];
  var match$4 = e.curve;
  if (!match$4) {
    return [
            Curry._2(Printf.sprintf(/* Format */{
                      _0: {
                        TAG: /* String_literal */11,
                        _0: "M ",
                        _1: {
                          TAG: /* Float */8,
                          _0: /* Float_f */0,
                          _1: /* No_padding */0,
                          _2: /* No_precision */0,
                          _3: {
                            TAG: /* Char_literal */12,
                            _0: /* " " */32,
                            _1: {
                              TAG: /* Float */8,
                              _0: /* Float_f */0,
                              _1: /* No_padding */0,
                              _2: /* No_precision */0,
                              _3: /* End_of_format */0
                            }
                          }
                        }
                      },
                      _1: "M %f %f"
                    }), sX, sY),
            Curry._2(Printf.sprintf(/* Format */{
                      _0: {
                        TAG: /* String_literal */11,
                        _0: "L ",
                        _1: {
                          TAG: /* Float */8,
                          _0: /* Float_f */0,
                          _1: /* No_padding */0,
                          _2: /* No_precision */0,
                          _3: {
                            TAG: /* Char_literal */12,
                            _0: /* " " */32,
                            _1: {
                              TAG: /* Float */8,
                              _0: /* Float_f */0,
                              _1: /* No_padding */0,
                              _2: /* No_precision */0,
                              _3: /* End_of_format */0
                            }
                          }
                        }
                      },
                      _1: "L %f %f"
                    }), tX, tY)
          ];
  }
  var match$5 = convertP(controlPoint(sx, sy, match$4._0), state);
  var match$6 = convertP(controlPoint(tx, ty, match$4._1), state);
  return [
          Curry._2(Printf.sprintf(/* Format */{
                    _0: {
                      TAG: /* String_literal */11,
                      _0: "M ",
                      _1: {
                        TAG: /* Float */8,
                        _0: /* Float_f */0,
                        _1: /* No_padding */0,
                        _2: /* No_precision */0,
                        _3: {
                          TAG: /* Char_literal */12,
                          _0: /* " " */32,
                          _1: {
                            TAG: /* Float */8,
                            _0: /* Float_f */0,
                            _1: /* No_padding */0,
                            _2: /* No_precision */0,
                            _3: /* End_of_format */0
                          }
                        }
                      }
                    },
                    _1: "M %f %f"
                  }), sX, sY),
          Curry._6(Printf.sprintf(/* Format */{
                    _0: {
                      TAG: /* String_literal */11,
                      _0: "C ",
                      _1: {
                        TAG: /* Float */8,
                        _0: /* Float_f */0,
                        _1: /* No_padding */0,
                        _2: /* No_precision */0,
                        _3: {
                          TAG: /* Char_literal */12,
                          _0: /* " " */32,
                          _1: {
                            TAG: /* Float */8,
                            _0: /* Float_f */0,
                            _1: /* No_padding */0,
                            _2: /* No_precision */0,
                            _3: {
                              TAG: /* String_literal */11,
                              _0: ", ",
                              _1: {
                                TAG: /* Float */8,
                                _0: /* Float_f */0,
                                _1: /* No_padding */0,
                                _2: /* No_precision */0,
                                _3: {
                                  TAG: /* Char_literal */12,
                                  _0: /* " " */32,
                                  _1: {
                                    TAG: /* Float */8,
                                    _0: /* Float_f */0,
                                    _1: /* No_padding */0,
                                    _2: /* No_precision */0,
                                    _3: {
                                      TAG: /* String_literal */11,
                                      _0: ", ",
                                      _1: {
                                        TAG: /* Float */8,
                                        _0: /* Float_f */0,
                                        _1: /* No_padding */0,
                                        _2: /* No_precision */0,
                                        _3: {
                                          TAG: /* Char_literal */12,
                                          _0: /* " " */32,
                                          _1: {
                                            TAG: /* Float */8,
                                            _0: /* Float_f */0,
                                            _1: /* No_padding */0,
                                            _2: /* No_precision */0,
                                            _3: /* End_of_format */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    },
                    _1: "C %f %f, %f %f, %f %f"
                  }), match$5[0], match$5[1], match$6[0], match$6[1], tX, tY)
        ];
}

function edgeToSVG(state, e) {
  var match = edgeCurveD(state, e);
  var d = match[0] + match[1];
  return {
          hd: React.createElement("path", {
                key: e.edge_id,
                id: e.edge_id,
                d: d,
                fill: "none",
                stroke: e.draw ? "black" : "lightseagreen"
              }),
          tl: {
            hd: React.createElement("text", {
                  key: "text_" + e.edge_id,
                  fill: "blue",
                  fontSize: fontSize,
                  textAnchor: "middle"
                }, React.createElement("textPath", {
                      key: "textPath_" + e.edge_id,
                      startOffset: "50%",
                      xlinkHref: "#" + e.edge_id
                    }, e.edge_id)),
            tl: /* [] */0
          }
        };
}

function fillToSVG(state, fill) {
  var d = function (edges) {
    var func = function (prevCoordName, es) {
      if (!es) {
        return "z";
      }
      var rest = es.tl;
      var e = es.hd;
      var match = edgeCurveD(state, e);
      var c = match[1];
      if (prevCoordName === e.scoord) {
        return c + func(e.tcoord, rest);
      }
      var c$1 = AppState$YourProjectName.findCoordinate(state.coordinates, e.scoord);
      var tmp;
      if (c$1 !== undefined) {
        var match$1 = convert(c$1.x, c$1.y, state);
        tmp = Curry._2(Printf.sprintf(/* Format */{
                  _0: {
                    TAG: /* String_literal */11,
                    _0: "L ",
                    _1: {
                      TAG: /* Float */8,
                      _0: /* Float_f */0,
                      _1: /* No_padding */0,
                      _2: /* No_precision */0,
                      _3: {
                        TAG: /* Char_literal */12,
                        _0: /* " " */32,
                        _1: {
                          TAG: /* Float */8,
                          _0: /* Float_f */0,
                          _1: /* No_padding */0,
                          _2: /* No_precision */0,
                          _3: /* End_of_format */0
                        }
                      }
                    }
                  },
                  _1: "L %f %f"
                }), match$1[0], match$1[1]);
      } else {
        tmp = "";
      }
      return tmp + (c + func(e.tcoord, rest));
    };
    if (!edges) {
      return "";
    }
    var head = edges.hd;
    var match = edgeCurveD(state, head);
    return match[0] + (match[1] + func(head.tcoord, edges.tl));
  };
  var edges = AppState$YourProjectName.findEdges(state.edges, fill.edges);
  if (edges !== undefined) {
    return React.createElement("path", {
                key: fill.fill_id,
                d: d(edges),
                fill: Color$YourProjectName.toString(fill.color),
                stroke: "none"
              });
  } else {
    return React.createElement(React.Fragment, undefined);
  }
}

function Previewer(Props) {
  var state = Props.state;
  var coords = $$Array.of_list(List.concat({
            hd: List.map((function (param) {
                    return fillToSVG(state, param);
                  }), state.fills),
            tl: {
              hd: List.concat(List.map((function (param) {
                          return coordToSVG(state, param);
                        }), state.coordinates)),
              tl: {
                hd: List.concat(List.map((function (param) {
                            return edgeToSVG(state, param);
                          }), state.edges)),
                tl: /* [] */0
              }
            }
          }));
  return React.createElement("div", {
              className: "preview"
            }, React.createElement("svg", {
                  height: String(state.svgy),
                  width: String(state.svgx),
                  x: "0",
                  y: "0"
                }, coords));
}

var RR;

var distControlPoint = 0.5;

var make = Previewer;

export {
  RR ,
  convert ,
  convertP ,
  fontSize ,
  coordToSVG ,
  distControlPoint ,
  controlPoint ,
  edgeCurveD ,
  edgeToSVG ,
  fillToSVG ,
  make ,
  
}
/* react Not a pure module */
